import Vue from 'vue'
import { mapGetters, mapActions, mapState } from 'vuex';

import TrackingLastPositionBusesService from 'js/services/api/tracking/last-position-buses.js'
import SchedulesServices from 'js/services/api/schedules/planned_schedules';
import OperatorService from 'js/services/api/entity/operator/operator.js';
import TopologySublinesService from 'js/services/api/topology/sublines.js'
import IncidencesService from '../../../js/services/api/tracking/incidences';
import TopologyRoutesService from 'js/services/api/topology/routes.js'

import SublineItem from './_subline-item'
import Loading from './_loading'
import BusCard from './_bus-card'
import moment from 'moment-timezone';
import TimePicker from 'vue2-timepicker'
import template from './content.pug'

const PLANNED_INCIDENCE = 'planned';
const STOP   = 'stops'
const ROUTE  = 'route'
const ROUTES = 'routes'
const OTP    = 'OTP'
const MAP    = 'map'

// @vue/component
export default Vue.extend({
  template: template(),

  components: {SublineItem, Loading, BusCard, TimePicker},

  props: {
    stop: {
      type: Object,
      required: true,
      default: null
    },

    routes: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      route: null,
      buses: [],
      sublines: [],
      incidences: [],
      retryTime: 2000, // retry time for failed requests
      reloadBusesTime: 5000, // recharge time of bus positions
      busesRequestFinished: false,
      localTime: '',
      datasublineaparada: {},
      previousColor: '',
      backgroundPreviousDate: '',
      colorPreviousDate: '',
      busestiemporeal: [],
      incidenceModal: false,
      currentIncidenceModal: null,
      counterDate: 0,
      hito: '',
      openListLine: false,
      showModalHito: false,
      showModal: false,
      timeZone: '',
      timeoutRun: true,
      tab: 0,
      firstLoadingData: true,
      showInfo: false,
      openedDetailsIndex: null,
      lastPositionBuses: [],
      lineInfo: null,
      /**
       * array of object {details: {}, schedules: []}
       * details: {
       *  datasublineaparada.destination_route = route.destination
          datasublineaparada.line_name = route.line_name
          lineInfo = route
       * }
       */
      plannedSchedules: [],
      dateForm: moment().format('YYYY-MM-DD'),
      timeForm: moment().format('HH:mm'),
      plannedSchedulesLoaded: false,
      currentOperator: undefined,
      // original response SchedulesServices
      // used to filter after changing the time in the form
      responsePlannedScheduleService: [],
      // When we change the date and it is different from today's date
      // hide real time
      hideRealTime: false,
      minDate: '',
      // Flag to ignore toggleDetails
      ignoreToggle: false,
      hourRange: [],
      minuteRange: [],
      routeStops: [] // points for routes
    }
  },

  computed: {
    ...mapGetters([
      'entryPointGetters'
    ]),

    ...mapState(['points']),

    filteredSublines() {
      return this.sublines;
    },

    position() {
      return {
        lat: this.stop.lat,
        lng: this.stop.lng,
      };
    },

    user() {
      return !!this.$store.state.currentUser;
    },

    stopRoutes() {
      const routeIds = this.stop.route_ids || this.stop.routeIds || []

      if (this.routes.length) { return this.routes.filter(r => routeIds.includes(r.id)) }
      if (this.stop.routes && this.stop.routes.length) { return this.stop.routes }
      if (this.stop.routeSummaries && this.stop.routeSummaries.length) { return this.stop.routeSummaries }

      return []
    },

    visibleRoutes() {
      return this.stopRoutes.filter(r => r.visible_for_client)
    },

    maxBusTime() {
      return this.$store.state.maxBusTime;
    },

    stops() {
      return this.$store.state.stops;
    },

    datepickerConfig() {
      const currentLocale = Vue.i18n.locale;
      const calendarLocales = Vue.i18n.locales || {};

      return {
        allowInput: true,
        minDate: moment().startOf('day').toDate(),
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd/m/Y', 
        onChange: (dates, dateStr) => {
          this.dateForm = dateStr; 
        },
        disableMobile: true,
        locale: calendarLocales[currentLocale] || 'default'
      }
    },
  },

  watch: {
    stop() {
      this.reset()
    },

    administrativeArea: {
      handler: 'loadInformation',
      immediate: true,
    },

    // this date change in form
    dateForm(newValue, oldValue) {
      if(newValue == "") return

      // Validate if the new date is less than the current date
      if (moment(newValue).isBefore(moment(), 'day')) {
        // If it is lower, keep the previous value
        this.dateForm = moment().format('YYYY-MM-DD')
        return;
      }

      this.setTimeRanges();
      // Validate current date.
      // If it corresponds to the current date, we will show real time
      if (moment().format('YYYY-MM-DD') == moment(newValue).format('YYYY-MM-DD')) {
        this.hideRealTime = false
      } else {
        this.hideRealTime = true
        this.tab = 1
      }

      // load planned schedule if change date form
      if (this.loadingSchedulejourneys) {
       // Vue.notifications.failure(this.$t('stops.notifications.loadingSchedules'))
      }

      if(moment(newValue).format('YYYY-MM-DD') != moment(oldValue).format('YYYY-MM-DD')) {
        this.plannedSchedules = []
        this.plannedSchedulesLoaded = false
        // Reload planned schedule if date is changed
        this.loadPlanedSchedules();
      }
    },

    // If change hour, call filter planned schedules
    // formatDataPlannedSchedules()
    timeForm(newValue, oldValue) {
      // load planned schedule if change date form
      if (this.loadingSchedulejourneys) {
       // Vue.notifications.failure(this.$t('stops.notifications.loadingSchedules'))
      }

      if(newValue != oldValue) {
        this.plannedSchedules = []
        this.plannedSchedulesLoaded = false
        this.entryPointGetters.previousLocation === STOP ?
          this.formatDataPlannedSchedules(this.responsePlannedScheduleService) :
          this.responsePlannedScheduleService.map(object => this.formatDataPlannedSchedules(object));
        this.loadingSchedulejourneys = false;
        this.plannedSchedulesLoaded = true;
      }
    }
  },

  created() {
    this.reset()
    this.getOperators();
    this.loadIncidences();
    this.setMinDate();
    this.setTimeRanges();
    this.getRouteStops();
  },

  destroyed() {
    clearTimeout(this.requestTimeout)
  },

  methods: {
    ...mapActions(['loadMunicipalityPoints']),

    reset() {
      this.plannedSchedules = []
      this.firstLoadingData = true
      this.plannedSchedulesLoaded  = false
      this.loadNextBuses()
      this.getSublines()
      this.getOperators()
    },

    // Get points for placing stops on the map in order
    async getRouteStops() {
      if (!this.route?.id) { return }
      const params = {
        route_id: this.route?.id,
        stops: this.stops
      }
      await this.loadMunicipalityPoints(params)
      this.routeStops = this.points
    },

    async getOperators() {
      try {
        const params = {
          administrative_area_id: this.$municipality.administrative_area_id,
        };
        const response = await OperatorService.index(params);
        this.operators = response.data;
        const routeIds = this.route?.id;
        this.imageOperator = this.operators
          .flatMap((operator) =>
            operator.route_ids
              .filter((routeId) => routeIds?.includes(routeId))
              .map(() => operator.logo_url)
          )
          .find((imgUrl) => imgUrl !== undefined);
      } catch (error) {
        console.error('error', error)
      }
      this.loadPlanedSchedules();
      this.plannedSchedulesLoaded = false
    },

    loadImageOperator(){
      return this.$store.state.stop.logo_url
    },

    truncate20(value) {
      if (!value) return '';
      return value.length > 20 ? value.slice(0, 20) + '...' : value;
    },

    loadInformation() {
      if (this.administrativeArea) {
        this.date = moment().format('YYYY/MM/DD');
        this.loadNextBuses();
      }
    },

    // Carga de incidencias
    async loadIncidences() {
      const paramsIncidence = {
        active: true,
        route_ids: this.stop.route_ids,
      };
      await IncidencesService.index({
        paramsIncidence,
      }).then((response) => {
        this.incidences = response.data;
      });
    },

    searchIncidence(busRouteId) {
      return this.incidences.some((incidence) =>
        incidence.route_ids.some((route) => route === busRouteId)
      );
    },

    // Use in Intl.DateTimeFormat
    hourInSecond(date){
      // Extract hour, minute, and second from formatted date and time
      // For this example, we assume that `date` returns something like "May 22, 2025, 20:55:29"
      const partsDate = date.match(/(\d{2}):(\d{2}):(\d{2})/);
      const hours = parseInt(partsDate[1], 10);
      const minutes = parseInt(partsDate[2], 10);
      const seconds = parseInt(partsDate[3], 10);

      // Calculate the total seconds since midnight
      const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;

      return totalSeconds
    },

    async loadNextBuses() {
      if (!this.loadingBuses && this.timeoutRun) {
        this.loadingBuses = true
        this.timeZone =  this.$municipality.time_zone
        /* eUsing 'es-ES' in Intl.DateTimeFormat is required if you want to
            specify the language for the date and time format.
          'es-ES': Indicates that the date and time should be formatted according
            to the conventions of the Spanish language used in Spain.
         */
        const currentDateFormated = new Intl.DateTimeFormat('es-ES', {
          timeZone: this.timeZone, hour: '2-digit', minute: '2-digit', second: '2-digit',
          year: 'numeric', month: 'long', day: 'numeric', hour12: false}).format(new Date());

        // Store the local time in seconds in thisTime
        this.thisTime = this.hourInSecond(currentDateFormated)

        const params = {
          // Code is still used instead of display_code because it is unique.
          // todo send line or subline
          stop_code: this.stop.code,
          last_seconds: 300,
          order_by: 'updated_at', // important to take the last bus
          order_dir: 'desc',
          calculated: true,
          administrative_area_id: this.$municipality.administrative_area_id,
          municipality_id: this.$municipality.id
        };

        // Get of tracking/last_position_buses
        // Searching for last position buses for a specific stop
        TrackingLastPositionBusesService.index({params, skipLoading: true}).then(
          (response) => {
            const busPosition = []
            const realTimeBusesSet = new Set();
            // Discard those whose time is 0 (they have already passed through the stop)
            // The records arriving from last position buses are scanned.
            /**
             * Example response
             * response = {
             *  times = {
             *    stops_code: time
             *  }
             * }
             */
            response.forEach((position) => {
              if (
                position.times[this.stop.code] > 0 &&
                position.times[this.stop.code] <= this.maxBusTime
              ) {
                position.time = Math.round(position.times[this.stop.code] / 60.0);
                position.isIncidence = this.searchIncidence(position.route_id);
                busPosition.push(position);
                realTimeBusesSet.add(position.time);
              }
            });

            if (busPosition.length > 0) {
              this.lastPositionBuses = _.sortBy(
                busPosition,
                (bus) => bus.times[this.stop.code]
              )
            }
            /** For when accessed from the main menu MAP
             * A method will be launched that will order the planned schedule.
             * to show first those that bring real time.
             * Use the realTimefield within the plannedSchedule
             */
            if(this.entryPointGetters.previousLocation === MAP){
              this.sortAndFilterPlannedSchedules()
            }

            this.loadingBuses = false
            this.busesRequestFinished = true
          },
          () => {
            this.loadingBuses = false
            this.busesRequestFinished = true
            this.requestTimeout = setTimeout(this.loadNextBuses, this.retryTime);
          }
        );

        /** Control of first loading before displaying on screen */
        if (this.firstLoadingData) {
          this.showInfo = true

          const realTimePresence = this.plannedSchedules.some(
            plannedSchedule => this.filtrateLastPositionBuses(plannedSchedule).length > 0
          )

          this.tab = realTimePresence ? 0 : 1

          this.firstLoadingData = false
        }

        this.requestTimeout = setTimeout(
          this.loadNextBuses,
          this.reloadBusesTime
        );
      }
    },

    /** Planned SChedule is array of object {id: , schedules : [], sublineDetails: {}}
     * Add new field realTime= [{}]
     *
     * This method allows you to sort and filter the elements that will be displayed
     * when entering from the main menu.
     * First, check if there is real-time data to prioritize and display it first.
     * Second, sort the planned times using the first record to check the most recent
     * Third, remove from the list those whose first record corresponds to the following day
    */
    sortAndFilterPlannedSchedules(){
      // Iterate plannedSchedule and validate if have in real time
      this.plannedSchedules = this.plannedSchedules.map(plannedSchedule => {
        const realTime = this.filtrateLastPositionBuses(plannedSchedule)

        if(realTime.length > 0){
          return {
              ...plannedSchedule, // Copy existing properties
              realTimeData: realTime// Add new field
          };
        } else {
          // Creates a copy of the object and removes the realTimeData field if it exists
          // Destructures and excludes realTimeData
          const { realTimeData, ...rest } = plannedSchedule;
          // rest will contain all properties except realTimeData
          return rest;
        }
      })

      // Sort by showing first those that bring real-time data
      this.plannedSchedules.sort((a, b) => {
        // Prioritize objects that have `realTimeData` over those that don't
        if (a.realTimeData && !b.realTimeData) return -1; // `a` goes before `b`
        if (!a.realTimeData && b.realTimeData) return 1;  // `b` goes before `a`

        // If both have `realTimeData`, sort by the lowest `time` of the first element
        if (a.realTimeData && b.realTimeData) {
            const aTime = a.realTimeData[0]?.time || 0;
            const bTime = b.realTimeData[0]?.time || 0;
            return aTime - bTime; // Sort by shortest `time`
        }

        // If none have `realTimeData`, sort by `scheduleDate`
        const aScheduleDate = new Date(a.schedules[0].scheduleDate)
        const bScheduleDate = new Date(b.schedules[0].scheduleDate)
        return aScheduleDate - bScheduleDate; // Sort by earliest scheduleDate
      });

      const nextDay = moment().add(1, 'days').format('DD/MM');

      this.plannedSchedules = this.plannedSchedules.filter(plannedSchedule => {
        return plannedSchedule.schedules[0].fecha !== nextDay;
      });
    },

    // This method ensures that the order of the elements given by OTP are correct
    sortOtpItems(){
      this.plannedSchedules.forEach(item => {
        item.schedules.sort((a, b) => new Date(a.scheduleDate) - new Date(b.scheduleDate));
      });
    },

    formatDate(date) {
      const dia = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      const mes = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      return `${dia}/${mes}`;
    },

    getFormattedTime(timeString) {
      const [hours, minutes] = timeString.split(':');
      return `${hours}:${minutes}`;
    },

    formatDateMachine(date) {
      // Extract the components you need from the date using methods of the Date object
        const year = date.getFullYear();
      // Add 1 because months start at 0
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const formatedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
      return formatedDate
    },

    /**
     * Generate structure journey with details
     * @param {*} serviceis object of schedule journey
     * @returns array of journey
     */
    processSchedules(serviceData) {
      const fechaActual = new Date();
      /** The structure that comes from all planned is different from that of planned schedule
       *
       * [{
          "id": "68414775fffef15028ec8ce7",
          "subline_code": "100419000000010001",
          "subline_name": "1",
          "journey_time": "04:43:00",
          "is_real_time": false,
          "route_id": "684151ed91490b6d73b0f241",
          "has_incidence": false,
          "arrival_bus_by_stop_and_journey": "04:51:00",
          "code": "4508300",
          "date": "2025-06-23T04:51:00.000+00:00",
          "route_description": ""
        }]
       *
      */
      const dataToIterate = this.entryPointGetters.previousLocation === STOP ?
                              serviceData:
                              serviceData.schedule_journeys

      return dataToIterate.reduce((acumulador, schedule) => {
        if (schedule.arrival_bus_by_stop_and_journey) {
          // Remove the +00:00 part so that JS interprets the date as local
          // To interpret the date as is without adjusting the time zone, the time zone
          // part of the string is removed and the date is created as a local date.
          const dateStr = schedule.date.replace(/Z|([+-]\d{2}:\d{2})$/, '');
          const scheduleDate = new Date(dateStr);

          /** It must be ensured that, regardless of my geographical location, the schedules
           * corresponding to Valencia are shown, ensuring that the bus arrival time is shown.
           * */
          // Remove the +00:00 from the string that forces the UTC
          const dateJourney =  schedule.date.substring(0, schedule.date.indexOf('+'));
          //dateJourney = 2025-06-26T05:14:00.000
          // return in the next format 2025-07-02 22:45
          const formattedDate = this.formatDateMachine(new Date(dateJourney))
          // Get current time zone
          const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          // Date without explicit time zone
          const inputDate = `${this.dateForm}T${this.timeForm}:00`
          // Interpret device time
          const currentTime = moment.tz(inputDate, browserTimeZone);
          // convert to the time defined in the municipality
          const timeZoneMuncipality = this.$municipality.time_zone

          const formattedDateForm = currentTime.tz(timeZoneMuncipality);
          // transforming the form data to the time zone given by the administrator.
          // to show only those steps that apply.
          if (parseInt(moment.tz(formattedDate, timeZoneMuncipality).format('x')) >=
              parseInt(moment.tz(formattedDateForm.format('YYYY-MM-DD HH:mm:ss'),timeZoneMuncipality).format('x'))
            ) {
            const newTime = this.getFormattedTime(schedule.arrival_bus_by_stop_and_journey);
            const valid = this.formatDate(scheduleDate) === this.formatDate(fechaActual);
            const differentDaysFormat = `${ this.formatDate(scheduleDate)} - ${newTime}`;
            this.hito = schedule.route_description

            // this section if for validate positon warning
            const dateJourney = new Date(schedule.date);
            const month = dateJourney.getMonth() + 1 < 10 ? '0' + (dateJourney.getMonth() + 1) : dateJourney.getMonth() + 1;
            const day = dateJourney.getDate() < 10 ? '0' + dateJourney.getDate() : dateJourney.getDate();
            const aux_date = `${day}/${month}`;

            acumulador.push({
              time: valid? newTime : differentDaysFormat,
              subline_name: schedule.subline_name,
              position: '',
              is_real_time: false,
              route_id: schedule.route_id,
              incidences: schedule.incidences,
              fecha: this.formatDate(scheduleDate),
              journey_time: schedule.journey_time,
              colortexto: valid? '' : 'date-text-color',
              code: schedule.code,
              styleImgWarning: this.validateImgWarning(aux_date),
              scheduleDate: moment.tz(formattedDate, timeZoneMuncipality).toISOString()
            });
          }
        }

        return acumulador;
      }, []);
    },

    // Main processing function
    formatDataPlannedSchedules(response) {
      let objectPlannedSchedule = {}
      let scheduleJourneys = this.processSchedules(response);

      if(scheduleJourneys.length == 0){
        // This occurs when there are no schedules to display within the defined time range.
        this.plannedSchedulesLoaded = true
        return
      }
      // Optional Sorting and Filtering
      // seenTimes: This is a Map used to keep track of times that have already been viewed.
      // The idea is to eliminate buses that have duplicate times.
      const seenTimes = new Map();
      scheduleJourneys = scheduleJourneys.filter(schedule => !seenTimes.has(schedule.time) && seenTimes.set(schedule.time, true));

      objectPlannedSchedule.id = scheduleJourneys?.[0].code
      objectPlannedSchedule.schedules = scheduleJourneys
      objectPlannedSchedule.sublineDetails = this.generateSublineDetails(response)

      let foundObject = this.plannedSchedules.find(objeto => objeto.id === scheduleJourneys?.[0].code);
      if (!foundObject) {
        this.plannedSchedules.push(objectPlannedSchedule)
      }
    },

    generateSublineDetails(data = undefined){
      if (this.entryPointGetters.previousLocation === STOP) {
        if (this.routes?.length) {
          const route = this.routes.find(
            r => r.id === this.entryPointGetters.routeId
          )
          if (route) {
            // Load the specific route destination, use subline details
            return {
              destinationRoute: route?.destination,
              lineName: route?.subline_name,
              lineInfo: route
            }
          }
        }
      } else {
        return {
          destinationRoute: data.destination,
          lineName: data.line_name,
          lineInfo: data
        }
      }
    },

    async loadPlanedSchedules() {
      // This boolean check if now running planned schedules service
      if(this.loadingSchedulejourneys) return

      this.loadingSchedulejourneys = true

      // generate params for get planned schedules
      const params = {
        municipality_id: this.$municipality.id,
        active: true,
        order_by: 'updated_at',
        stop_id: this.stop.id,
        skipLoading: true,
        date: this.dateForm
      }

      /* client/core/src/js/vue-plugins/vuex/index.js
      *In the file indicated in the method loadMunicipalityStops
      * The operator id for the stop is being obtained based on the operator associated with the route.
      * taking the first operator.
      */
      if(this.entryPointGetters.previousLocation === STOP) {
        let operator_id = this.stop.operator_id
        params.operator_id = operator_id
        this.currentOperator = this.operators.find(operator => operator.id === operator_id);
      } else {
        let operator_id = this.$store.state.stop.operator_id
        params.operator_id = operator_id
        this.currentOperator = this.operators.find(operator => operator.id === operator_id);
      }

      // validate the selected engine in the operator to call the service
      try {
        if ( this.currentOperator?.engine_for_recovery_of_planned_schedules === OTP) {
          // engine OTP
          await this.plannedScheduleServiceOpt(params)
        } else {
          // engine Moverick
          await this.plannedScheduleServiceMoverick(params)
        }
      } catch(error) {
        console.error('Error al obtner planned schedules', error);
        this.loadingSchedulejourneys = false;
      }
    },

    // Call new service, get of OTP
    async plannedScheduleServiceOpt(params){
      if(this.entryPointGetters.previousLocation === STOP) {
        params.route_id = this.entryPointGetters.routeId
        params.type = ROUTE
      } else {
        params.type = ROUTES
      }

      await SchedulesServices.plannedSchedulesOpt(params).then((response) => {
        //this.formatDataPlannedSchedules(response?.data?.data)
        // If the OTP service doesn't bring data, then I call Moverick's.
        if (response.data && response?.body?.data.length === 0) {
          this.plannedScheduleServiceMoverick(params)
          this.loadingSchedulejourneys = false;
        } else {
          // process OTP response
          // To process data by map or by stop section it goes differently
          this.responsePlannedScheduleService = response.body.data
          this.entryPointGetters.previousLocation === STOP ?
          this.formatDataPlannedSchedules(response.body.data) :
          response.body.data.map(object => this.formatDataPlannedSchedules(object));

          if(this.entryPointGetters.previousLocation === MAP){
            this.sortAndFilterPlannedSchedules()
          }
          // sort planned schedules OTP
          this.sortOtpItems()

          this.loadingSchedulejourneys = false;
          this.plannedSchedulesLoaded = true;
        }
      })
    },

    async plannedScheduleServiceMoverick(params){
      if(this.entryPointGetters.previousLocation === STOP) {
        params.route_id = this.entryPointGetters.routeId
        params.type = ROUTE

        // Call service plannedSchedules with type route
        await SchedulesServices.plannedSchedules(params).then((response) => {
          try {
            if(response?.data?.data.length > 0) {
               this.responsePlannedScheduleService = response?.data?.data
              this.formatDataPlannedSchedules(response?.data?.data)
            }
            this.loadingSchedulejourneys = false;
            this.plannedSchedulesLoaded = true
          } catch (error) {
            console.error('Error: ', error);
            this.loadingSchedulejourneys = false;
          }
        })
      } else {
        params.type = ROUTES
        // previousLocation is map
        // Call service allPlannedSchedules with type routes
        await SchedulesServices.plannedSchedules(params).then((response) => {
          try {
            this.responsePlannedScheduleService = response.data.data
            response.data.data.map(object => this.formatDataPlannedSchedules(object));

            this.sortAndFilterPlannedSchedules();

            this.loadingSchedulejourneys = false;
            this.plannedSchedulesLoaded = true;
          } catch (error) {
            console.error('Error: ', error);
            this.loadingSchedulejourneys = false;
          }
        })
      }
    },

    updateFavorite() {
      const user = this.$store.state.currentUser;
      let updatedIds = this.userFavorites;

      if (_.includes(updatedIds, this.stop.id)) {
        updatedIds = _.filter(updatedIds, (item) => item !== this.stop.id);
      } else {
        updatedIds.push(this.stop.id);
      }

      Vue.auth
        .update({
          favorite_stop_ids: updatedIds,
        })
        .then(() => {
          user.favorite_stop_ids = updatedIds;
          this.$store.commit('SET_CURRENT_USER', user);
        });
    },

    closeTOS() {
      this.showModal = false;
    },
    closeModalHito() {
      this.showModalHito = false;
    },

    toggleDetails( plannedSchedule ) {
      if (this.ignoreToggle) {
        // Reset the flag
        this.ignoreToggle = false;
         // Ignore execution
        return;
      }
      // Can validate if plannedSchedule hace real time
      // Verify that the boolean hideRealTime is false
      // hideRealTime, It is used to display real time only on the current date.
      if((plannedSchedule.realTimeData?.length > 0 || this.filtrateLastPositionBuses(plannedSchedule).length > 0) &&
         !this.hideRealTime) {
        this.tab = 0
      } else {
        this.tab = 1
      }
      this.openedDetailsIndex = this.openedDetailsIndex === plannedSchedule.id ? null : plannedSchedule.id;
    },

    /*
     * Open or close the stop bubble
     */

    toggleLineInfo() {
      this.openListLine = !this.openListLine;
    },

    /*
     * The stop bubble closes
     */

    closeStopsBubble() {
      if (this.openListLine) this.openListLine = false;
      if (this.showMapCaption) this.showMapCaption = false;
    },

    generateObject(journey, line_name) {
      this.localTime = new Date();
      this.localTime = this.localTime.toLocaleTimeString('it-IT')
      const localTimeComp = this.localTime.slice(
        0,
        this.localTime.length - 3
      );

      const dateJourney = new Date(journey.date);
      const newTime = journey.arrival_bus_by_stop_and_journey.split(':').slice(0, 2).join(':');
      const month = dateJourney.getMonth() + 1 < 10 ? '0' + (dateJourney.getMonth() + 1) : dateJourney.getMonth() + 1;
      const day = dateJourney.getDate() < 10 ? '0' + dateJourney.getDate() : dateJourney.getDate();
      const aux_date = `${day}/${month}`;
      /** It is validated if the date corresponds to the following day */
      const ElapsedTime = Date.now();
      const now = new Date(ElapsedTime)
      const validate_next_day = dateJourney.getDate() > now.getDate()
      const nextDay = day + dateJourney.toLocaleString('es-CL', {month: 'short'}) + ' - ' + newTime

      return {
        time: validate_next_day ? nextDay : newTime,
        subline_name: line_name,
        position: '',
        is_real_time: false,
        route_id: journey.route_id,
        timeInMinutes: this.differenceInMinutes(journey.arrival_bus_by_stop_and_journey, localTimeComp),
        isIncidence: journey.has_incidence,
        date: journey.date,
        code: journey.code,
        fecha: aux_date,
        colortexto: this.validateColor(aux_date),
        fechamostrar: this.validateDate(journey.date),
        incidences: journey.incidences,
        journey_time: journey.journey_time,
        styleImgWarning: this.validateImgWarning(aux_date),
        hito: journey.route_description
      };
    },

    differenceInMinutes(time_1, time_2) {
      // Helper function to convert HH:MM to minutes since midnight
      function convertToMinutes(time) {
        const [hour, minutes] = time.split(':').map(Number);
        return hour * 60 + minutes;
      }

      // Convert both times to minutes
      const min_time_1 = convertToMinutes(time_1);
      const min_time_2 = convertToMinutes(time_2);

      // Calculate the difference in minutes
      const difference = Math.abs(min_time_1 - min_time_2);

      return difference;
    },

    timeInSeconds(time) {
      let [hour, minutes, seconds] = time.split(':').map(Number);
      return hour * 3600 + minutes * 60 + seconds;
    },

    validateDate(index, bus) {
      if (this.previousDate == bus) {
        return '-';
      } else {
        this.previousDate = bus;
        return bus + ' >>';
      }
    },

    validateDate2(index, date) {
      if (index == 0) {
        this.backgroundPreviousDate = date;
        this.previousColor = 'backgroundColorStop';
        return 'backgroundColorStop';
      } else if (this.backgroundPreviousDate == date) {
        return this.previousColor;
      } else {
        this.backgroundPreviousDate = date;
        if (this.previousColor == 'backgroundColorStop') {
          this.previousColor = 'backgroundColorStop1';
        } else {
          this.previousColor = 'backgroundColorStop';
        }
        return this.previousColor;
      }
    },

    validateColor(date) {
      this.counterDate = this.counterDate + 1

      if (this.counterDate == 1) {
        this.colorPreviousDate = date;
        return '';
      } else if (this.colorPreviousDate == date) {
        return '';
      } else {
        return 'colorTextDate';
      }
    },

    validateImgWarning(date){
      this.counterDate = this.counterDate + 1

      if (this.counterDate == 1) {
        this.colorPreviousDate = date;
        return 'img-warning';
      } else if (this.colorPreviousDate == date) {
        return 'img-warning';
      } else {
        return 'img-warning-next-day';
      }
    },

    /*
     * Check if a bus has not reported its position for more than 5 minutes.
     */
    checkInactiveBus(positionBus) {
      return moment(positionBus.last_valid_datetime).diff(moment().subtract(5, 'm'), 'm') < 0
    },

    /*
      data is element of processedData
      currentIncidenceModal have datails of incidence
      */
    openModal(data) {
      this.currentIncidenceModal = data.incidences?.[0]
      this.incidenceModal = true
    },

    closeModal(){
      this.currentIncidenceModal = null
      this.incidenceModal = false
    },

    /**
     *
     * @param {*} data journey object
     * @returns return true or false
     */
    validateIncidence(data) {
      /** data have array incidences
       * Verify that the fields
       * planned_end_date y planned_start_date
       * include to journey_time
       * Apply transformation of the time that arrives from journey to Date
      */

      // Get the current date
      let currentDate = new Date();
      const timeParts = data.journey_time.split(':');
      // Extracts year, month and day from the current date
      let year = currentDate.getFullYear();
      let month = currentDate.getMonth();
      let day = currentDate.getDate();
      const hours = timeParts[0];
      const minutes = timeParts[1];
      const seconds = timeParts[2];

      const journey = new Date(year, month, day, hours, minutes, seconds);

      let result = data?.incidences?.filter((inc) => {
        // Validation is still pending in the event that it is presented
        // inc unplanned and we should return true.
        if(inc.type == PLANNED_INCIDENCE) {
          const start = new Date(inc.planned_start_date);
          const end = new Date(inc.planned_end_date);
          /* if journey time exist into planning time, then show warning */
          if (journey >= start && journey <= end) {
            return inc
          }
        } else {
          // when inc type is unplanned show warning in all hours
          return inc
        }
      })

      return result?.length > 0
    },

    changeTab(index){
      this.tab = index
    },
    /**
     * @param {*} schedule
     * lastPositionBuses have
     *    "route_destination": "Gran Vía Ramón y Cajal 20 [València]",
     *    "route_origin": "Av. San Lorenzo frente a 189 [Torrent]",
     *    "next_point_name": "Av. Blasco Ibáñez 8 [Alaquàs]",
     *    subline_name: "161"
     *
     * schedule have
     *  destinationRoute: "Gran Vía Ramón y Cajal 20 [València]"
     *  lineName: "160"
     */
    filtrateLastPositionBuses(schedule) {
      return this.lastPositionBuses?.filter(
        (lastPosition) => lastPosition.route_destination == schedule?.sublineDetails?.destinationRoute &&
                          lastPosition.subline_name == schedule?.sublineDetails?.lineName
      )
    },

    /**
     * this methos help show the first time
     * validate if realtime or planned (use tab)
     */
    showOneTimeRealOrPlanned(journey = undefined){
      let lastPositionFiltered = []
      let time

      if(journey) {
        lastPositionFiltered = this.filtrateLastPositionBuses(journey)
        time = journey?.schedules[0]?.time
      }

      if (lastPositionFiltered && lastPositionFiltered.length > 0 && !this.hideRealTime) {

        return lastPositionFiltered[0]?.time + ' min';
      } else if (this.plannedSchedules && this.plannedSchedules.length > 0) {
        return time
      }
      return time
    },
    firstBusIconUrl(journey = undefined) {
      let lastPositionFiltered = []

      if(journey) {
        lastPositionFiltered = this.filtrateLastPositionBuses(journey)
      }
      if (this.lastPositionBuses && lastPositionFiltered.length > 0 && !this.hideRealTime) {
        return require('assets/images/rss-green.svg');
      } else if (this.plannedSchedules && this.plannedSchedules.length > 0) {
        return require('assets/images/calendar-check.svg');
      }
      return '';
    },

    async getSublines() {
      const params = {
        municipality_id: this.$municipality.id,
        route_ids: this.stop.route_ids,
        with_any_active_route: true,
        per: 0,
        template: 'passenger'
      }
      const response = await TopologySublinesService.index(params)

      this.sublines = response.data

      this.$emit('loaded-stop-sublines', this.sublines)
    },

    // Open modal with details line
    openLineInfo(plannedSchedule){
      // Set the flag to ignore the next click
      this.ignoreToggle = true;
      this.lineInfo = plannedSchedule.sublineDetails.lineInfo
      this.loadRoute(plannedSchedule?.schedules[0]?.route_id)
      this.$store.dispatch('loadMunicipalityStops', {route_id: plannedSchedule.schedules[0].route_id})
      this.toggleLineInfo()
    },

    async loadRoute(route_id) {
      await TopologyRoutesService.getRoute(route_id).then(routeResponse => {
        this.route = routeResponse.data
        this.getRouteStops()
      })
    },

    toRoute() {
      this.toggleLineInfo();
      this.$store.commit('setRoute', this.route);
      this.$router.push({
        name: 'municipality-routes',
        params : {
          sublineId: this.route?.subline_id,
          routeId: this.route?.id
        }
      });
    },

    setMinDate() {
      this.minDate = moment().format('YYYY-MM-DD');
    },
    setTimeRanges() {
       const isToday = moment(this.dateForm).isSame(moment(), 'day');

      if (isToday) {
        const currentHour = moment().hour();
        const currentMinute = moment().minute();

        // Rango de horas y minutos para el día de hoy.
        this.hourRange = [[currentHour, 23]];
        this.minuteRange = Array.from({ length: 60 - currentMinute }, (_, i) => currentMinute + i);

      } else {
        // Si la fecha es futura, se permite cualquier hora y minuto.
        this.hourRange = [[0, 23]];
        this.minuteRange = Array.from({ length: 60 }, (_, i) => i);
      }
    }
  }
})
